import type { Investment } from "../../types";

type NamedInvestment = Pick<Investment, "name" | "profileJoint" | "profileSdira" | "profileEntity">;

const updateProfileNames = (investment: NamedInvestment): void => {
  const { name } = investment;

  if (investment.profileEntity) {
    investment.profileEntity.profileName = name;
  }

  if (investment.profileSdira) {
    investment.profileSdira.profileName = name;
  }

  if (investment.profileJoint) {
    investment.profileJoint.profileName = name;
  }
};

export default updateProfileNames;
